import type { ReactNode, FC } from 'react'
import { type Servicepoint } from './model.js'
import { ServicepointListItemDesktop } from './ServicepointListItemDesktop.js'
import { ServicepointListItemMobile } from './ServicepointListItemMobile.js'

export type ServicepointListItemProps = {
  defaultExpanded?: boolean
  servicepoint: Servicepoint
  divider: boolean
  onSelect?: (servicepoint: Servicepoint) => void
  onClick?: (servicepoint: Servicepoint) => void
  children?: ReactNode
  showOpeningTimes?: boolean
  isDesktop?: boolean
  useDialogSelect?: boolean
}

export const ServicepointListItem: FC<ServicepointListItemProps> = ({ isDesktop = false, ...rest }) => {
  const ServicePointListItemComponent = isDesktop ? ServicepointListItemDesktop : ServicepointListItemMobile

  return <ServicePointListItemComponent {...rest} />
}
